import { Component } from "@angular/core";

@Component({
  selector: 'app-about',
  templateUrl: './app-about.component.html',
  standalone: false
})
export class AboutComponent { }
